import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Store } from '../models/siteProvider.ts';
import { fetchSiteProviderStores } from '../api/site-provider.ts';

export default function useSiteProviderStores(
  id: string,
): UseQueryResult<Store[], Error> {
  return useQuery<Store[]>({
    queryKey: ['siteProviderStores', id],
    queryFn: () => fetchSiteProviderStores(id),
    enabled: !!id,
  });
}
